import React, { Component } from "react";
import styled from "styled-components";
import { ModuleBase, ImageLoader } from "@loanbossinc/component-library";

const ModuleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0;
`;

const StyledImageLoader = styled(ImageLoader)`
  && {
    height: 124px;
    width: 124px;
  } 
`;

const Info = styled.div`
  margin: 35px 0 0;
  font-family: 'Lexend';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  user-select: none;
`;

const iconUrl = `${process.env.PUBLIC_URL}/images/no-data-available.svg`;

class NoDataAvailable extends Component {
  render() {
    return (
      <ModuleBase>
        <ModuleContainer>
          <StyledImageLoader src={iconUrl} />
          <Info>No Data Available</Info>
        </ModuleContainer>
      </ModuleBase>
    );
  }
}

export default NoDataAvailable;
